$(document).ready(function () {
  $(document).on("click", ".custom-accordion .ca-header", function () {
    $(this).toggleClass("active");
    $(this).next(".ca-content").slideToggle();
  }); 
});
$(document).on('click', '.header__icon--search', function () {
  let details = $(this).closest('details');
  setTimeout(function () {
    if (details.prop('open')) {
      details.attr('open', 'true');
    } else {
      details.attr('open', 'true').prop('open', true);
    }
  }, 10);
});
